export const switchStyles = {
  components: {
    Switch: {
      baseStyle: {
        _focus: {
          boxShadow: "none !important",
          outline: "none !important",
          border: "none !important",
        },
        _focusVisible: {
          boxShadow: "none !important",
          outline: "none !important",
          border: "none !important",
        },
        _active: {
          boxShadow: "none !important",
          outline: "none !important",
          border: "none !important",
        },
        _hover: {
          boxShadow: "none !important",
        },
      },
      parts: {
        track: {
          _focus: {
            boxShadow: "none !important",
            outline: "none !important",
            border: "none !important",
          },
          _focusVisible: {
            boxShadow: "none !important",
            outline: "none !important",
            border: "none !important",
          },
          _active: {
            boxShadow: "none !important",
            outline: "none !important",
            border: "none !important",
          },
        },
        thumb: {
          _focus: {
            boxShadow: "none !important",
            outline: "none !important",
          },
          _focusVisible: {
            boxShadow: "none !important",
            outline: "none !important",
          },
        },
      },
    },
  },
};

